/* eslint-disable no-self-compare */
import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import { NumericFormat } from "react-number-format";
import {
    useAccount,

} from "wagmi";
import { useModalContext } from '../../contexts/ModalContext';
import Web3 from 'web3';
import pillMlmAbi from '../../contract/pillMlmAbi.json'
import { contractAddress } from '../../contract/contractAddress';
import { approveToken, usdtTokenBalance } from '../../contract/TokenApprove';
import { useToast } from '../../hook/usetoast';
import { useGetTopUpVRS, useLevelTopUp } from './api/api';
import { decrypt } from '../../hook/encrypt';
import Slider from '@mui/material/Slider';
import { useProfileDetails } from '../profile-details/api/profileapi';
import { useGetTopUpAmount } from '../appPages/api/upgradeApi';
import { useAppKitAccount } from '@reown/appkit-controllers/react';

const TopUpLevelsModal = ({ modalOpen, modalClose }) => {
    const toast = useToast()
    const [value, setValue] = useState('')
    const [cooldownUntil, setCooldownUntil] = useState(null)
    const [remainingTime, setRemainingTime] = useState(0)
    const { connector } = useAccount();

    const { address } = useAppKitAccount()

    const { balance, setBalance, isloadingconnect, setIsloadingconnect } = useModalContext()
    const { data: userData } = useProfileDetails()

    const getCooldownKey = (addr) => `topupCooldown_${addr?.toLowerCase()}`

    const marks = [
        {
            value: 1,
            label: '1',
        },
        {
            value: 2,
            label: '2',
        },
        {
            value: 3,
            label: '3',
        },
        {
            value: 4,
            label: '4',
        },
        {
            value: 5,
            label: '5',
        },
        {
            value: 6,
            label: '6',
        },
        {
            value: 7,
            label: '7',
        },
        {
            value: 8,
            label: '8',
        },
        {
            value: 9,
            label: '9',
        },
        {
            value: 10,
            label: '10',
        },
        {
            value: 11,
            label: '11',
        },
        {
            value: 12,
            label: '12',
        },
        {
            value: 13,
            label: '13',
        },
        {
            value: 14,
            label: '14',
        },
        {
            value: 15,
            label: '15',
        },
        {
            value: 16,
            label: '16',
        },
        {
            value: 17,
            label: '17',
        },
        {
            value: 18,
            label: '18',
        },
        {
            value: 19,
            label: '19',
        },
        {
            value: 20,
            label: '20',
        },
    ];

    useEffect(() => {
        if (!address) return

        const stored = localStorage.getItem(getCooldownKey(address))

        if (stored && Date.now() < stored) {
            setCooldownUntil(parseInt(stored))
        } else {
            setCooldownUntil(null)
        }
    }, [address])
    useEffect(() => {
        if (!cooldownUntil || !address) return

        const interval = setInterval(() => {
            const diff = cooldownUntil - Date.now()

            if (diff <= 0) {
                setCooldownUntil(null)
                setRemainingTime(0)
                localStorage.removeItem(getCooldownKey(address))
                clearInterval(interval)
            } else {
                setRemainingTime(Math.floor(diff / 1000))
            }
        }, 1000)

        return () => clearInterval(interval)
    }, [cooldownUntil, address])

    const isCooldownActive = cooldownUntil !== null
    const [minValue, setMinValue] = useState();

    const [totalUsdt, setTotalUsdt] = useState()

    const [formWei, setFormWei] = useState()

    const [topUpLevel, setTopUpLevel] = useState()


    const [maxValue, setMaxValue] = React.useState([minValue, 20]);

    const userTopUp = useLevelTopUp()
    const { data: TopUpAmount } = useGetTopUpAmount()


    useEffect(() => {
        if (userData?.completedLevels !== undefined) {

            setMinValue((userData.completedLevels === 0 && userData.zorothlevelStatus === false) ? userData.completedLevels + 1 : userData.completedLevels + 2);
        }
    }, [userData]);
    const handleChange = async (event, newValue) => {
        const provider = await connector?.getProvider?.();

        if (!provider) {
            toast.error('Web3 provider not found');
            return;
        }

        const web3 = new Web3(provider);
        const toweiValue = web3.utils.toWei(value, 'ether')
        let updatedValue = [...newValue];  // Create a copy of the newValue array

        if (updatedValue[0] < minValue) {
            updatedValue[0] = minValue;
        }
        if (updatedValue[0] > minValue) {
            updatedValue[0] = minValue;
        }

        setMaxValue(updatedValue);

        const values = Array.from({ length: updatedValue[1] - updatedValue[0] + 1 }, (_, index) => [
            updatedValue[0] + index,
            toweiValue
        ]);

        setTopUpLevel(values)
        const usdtValue = values?.length * value
        setFormWei(usdtValue)

        const toweiusdtValue = web3.utils.toWei(usdtValue, 'ether')

        setTotalUsdt(toweiusdtValue)
    };
    const topUpVrs = useGetTopUpVRS()

    const close = async () => {
        modalClose()
    }
    const closeBtn = <button className="close" onClick={close}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3359 10.5L16.5547 14.7188C16.7891 14.9531 16.7891 15.3828 16.5547 15.6172L15.5781 16.5938C15.3438 16.8281 14.9141 16.8281 14.6797 16.5938L10.5 12.375L6.28125 16.5938C6.04688 16.8281 5.61719 16.8281 5.38281 16.5938L4.40625 15.6172C4.17188 15.3828 4.17188 14.9531 4.40625 14.7188L8.625 10.5L4.40625 6.32031C4.17188 6.08594 4.17188 5.65625 4.40625 5.42188L5.38281 4.44531C5.61719 4.21094 6.04688 4.21094 6.28125 4.44531L10.5 8.66406L14.6797 4.44531C14.9141 4.21094 15.3438 4.21094 15.5781 4.44531L16.5547 5.42188C16.7891 5.65625 16.7891 6.08594 16.5547 6.32031L12.3359 10.5Z" fill="#6E737E" />
        </svg>
    </button>;

    useEffect(() => {
        usdtBalance()
        if (TopUpAmount?.data) {
            checkTopup()


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, sessionStorage.getItem('user_JWT'), TopUpAmount, maxValue, modalOpen])

    const checkTopup = async () => {
        const provider = await connector?.getProvider?.();

        if (!provider) {
            return;
        }

        const web3 = new Web3(provider);
        setValue(TopUpAmount?.data?.amount)
        const toweiValue = web3.utils.toWei(TopUpAmount?.data?.amount, 'ether')

        const values = Array.from({ length: maxValue[1] - maxValue[0] + 1 }, (_, index) => [
            maxValue[0] + index,
            toweiValue
        ]);
        setTopUpLevel(values)
        const usdtValue = values?.length * TopUpAmount?.data?.amount
        setFormWei(usdtValue)
        const toweiusdtValue = web3.utils.toWei(usdtValue, 'ether')
        setTotalUsdt(toweiusdtValue)
    }


    const usdtBalance = async () => {
        try {
            const res = await usdtTokenBalance(address, connector)

            setBalance(res)
        } catch (error) {

        }
    }





    const onSubmit = async () => {
        setIsloadingconnect(true)
        await usdtBalance()
        if (parseFloat(formWei) > balance) {
            toast.error("Insufficient USDT balance")
            setIsloadingconnect(false)
            return

        }
        try {
            const provider = await connector?.getProvider?.();

            if (!provider) {
                toast.error('Web3 provider not found');
                setIsloadingconnect(false)
                return;
            }

            const web3 = new Web3(provider);
            const topUpContract = new web3.eth.Contract(pillMlmAbi, contractAddress?.pillMLM);

            const buyTimeStamp = await topUpContract.methods.timeStamp().call()

            const vrsRes = await topUpVrs.mutateAsync({ user_address: address, amount: totalUsdt, deadline: buyTimeStamp.toString() })




            if (vrsRes?.status) {
                const res = await approveToken(totalUsdt, address, toast, connector)

                if (res === true) {
                    const fiveMin = Date.now() + 3 * 60 * 1000
                    setCooldownUntil(fiveMin)
                    localStorage.setItem(getCooldownKey(address), fiveMin)
                    const estimatedGas = await topUpContract.methods.payforTopUp(topUpLevel, decrypt(vrsRes?.gcjgnvjfg), decrypt(vrsRes?.dfgdgbmn)).estimateGas({ from: address })

                    const topUpTx = await topUpContract.methods.payforTopUp(topUpLevel, decrypt(vrsRes?.gcjgnvjfg), decrypt(vrsRes?.dfgdgbmn)).send({ from: address, gas: estimatedGas })

                    if (topUpTx.transactionHash) {
                        const topUpData = {
                            startlevel: maxValue[0] - 1,
                            endlevel: maxValue[1] - 1,
                            amount: value,
                            hash: topUpTx.transactionHash
                        }


                        const res = await userTopUp.mutateAsync(topUpData)
                        if (res?.status) {
                            modalClose()
                        }
                    }

                }
            } else {
                setIsloadingconnect(false)
            }

        } catch (error) {

            setIsloadingconnect(false)

            const errorMessage = error?.reason || error?.message || "Transaction rejected";
            toast.error(`Transaction Failed: ${errorMessage}`);
            if (errorMessage && address) {
                setCooldownUntil(null)
                localStorage.removeItem(getCooldownKey(address))
            }
        } finally {
            setIsloadingconnect(false)
        }
    }

    useEffect(() => {
        setMaxValue([minValue, 20]);
    }, [minValue]);

    return (
        <Modal isOpen={modalOpen} centered="true" className="mymodal" backdropClassName="modalbackbg">
            <ModalHeader close={closeBtn}>Top-up Level <span> {maxValue[1] === maxValue[0] ? maxValue[0] : `${maxValue[0]} ${"-"} ${maxValue[1]}`}
            </span></ModalHeader>

            <ModalBody>
                <>
                    <div className='form-group formInputs'>
                        <label htmlFor='level'>Level</label>

                        <Slider
                            className='customslider slider-labels'
                            value={maxValue}
                            onChange={handleChange}
                            valueLabelDisplay="auto"
                            min={1}
                            max={20}
                            marks={marks}
                        />



                    </div>
                    <div className='form-group formInputs'>
                        <label htmlFor='amount'>Amount</label>
                        <div className='input-group'>
                            <NumericFormat
                                value={formWei}
                                className="form-control"
                                placeholder="0.00"
                                allowNegative={false}
                                readOnly


                            />
                            <div className='input-group-append'>
                                <div className="input-group-text border-left rounded-0 text-white" style={{ 'borderColor': 'rgba(255,255,255,0.1) !important' }}>
                                    USDT
                                </div>
                            </div>

                        </div>

                    </div>
                    <h6>Per Level :{value} USDT</h6>
                    {isCooldownActive && (
                        <p style={{ color: 'red' }}>
                            Try again in {Math.floor(remainingTime / 60)} min {remainingTime % 60} sec
                        </p>
                    )}

                    <div className='text-center'>
                        <div className='mt-4 mb-3'>
                            <button className='btn btn-primary px-4 px-lg-5' disabled={!TopUpAmount?.data?.amount || isloadingconnect || TopUpAmount?.data?.amount === '' || formWei === undefined || isCooldownActive} onClick={() => onSubmit()}>Top-Up Now</button>
                        </div>
                    </div>
                </>
            </ModalBody>
        </Modal>
    )
}

TopUpLevelsModal.propTypes = {
    modalOpen: PropTypes.any.isRequired,
    modalClose: PropTypes.any.isRequired,
};
export default TopUpLevelsModal;